// extracted by mini-css-extract-plugin
export default {"MainCardTable":"MainCardTable_MainCardTable__KNXF9"};